import { render, staticRenderFns } from "./jieshou.vue?vue&type=template&id=640ce556&scoped=true"
import script from "./jieshou.vue?vue&type=script&lang=js"
export * from "./jieshou.vue?vue&type=script&lang=js"
import style0 from "./jieshou.vue?vue&type=style&index=0&id=640ce556&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640ce556",
  null
  
)

export default component.exports